<template>
  <!-- 自定义消息-邀请视频 -->
  <div class="invite-video" :class="{ right: isMe }">
    <div class="info-wrap">
      <div class="des-wrap">
        <!-- <uni-icons type="videocam" size=".768rem"></uni-icons> -->
        <img class="image" :src="videoIcon" />
        <span class="des">{{ isMe ? '医生' : '受者' }}邀请您视频通话</span>
      </div>
      <div v-if="showBtn" class="join-btn">
        <span class="btn" @click="onJoin">进入视频</span>
      </div>
    </div>
  </div>
</template>

<script>
import { receiveInviteVideo } from '@/timpackage/utils/timInit'
import videoIcon from '@/static/video_icon2@2x.png'
export default {
  name: 'imCustomInvite',
  props: {
    showBtn: {
      // 是否显示进入视频按钮
      type: Boolean,
      default: true
    },
    message: {
      type: Object,
      default() {
        return {
          payload: {}
        }
      }
    }
  },
  data() {
    return {
      videoIcon
      // messageContext: {
      //   visitID: '965833164455469687',
      //   fromRole: 'Owner', // Owner 表示受者
      //   fromAccount: '26373_1422735307425296385',
      //   fromName: '王天宇',
      //   toRole: 'Member', // Member 表示医生
      //   toAccount: '26373_1377646294482329601',
      //   toAccount: '杨医生',
      //   groupId: 'G0578497569430030043984845748'
      // }
    }
  },
  computed: {
    isMe() {
      return this.message.flow === 'out'
    },
    messageContext() {
      const data = JSON.parse(this.message.payload.data)
      try {
        if (data.data) {
          // 兼容群组通知ui发送的自定义消息
          const target = JSON.parse(data.data)
          if (target.userData) {
            const userData = JSON.parse(target.userData) || {}
            return userData.content
          }
        }
      } catch (e) {
        console.log(e)
      }
      return data.content
    }
  },
  methods: {
    onJoin() {
      receiveInviteVideo(this.messageContext)
    }
  }
}
</script>

<style lang="scss" scoped>
.invite-video {
  display: flex;

  .info-wrap {
    width: 6.997333rem;
    padding: 0.682667rem;
    // box-shadow: 0rem .128rem .426667rem 0rem #ebeff9;
    border-radius: 0 0.597333rem 0.597333rem 0.597333rem;
    background: #ffffff;
  }

  .des-wrap {
    display: flex;
    font-size: 0.64rem;
    line-height: 0.768rem;
    color: #222222;
    font-weight: bold;
    text-align: left;

    & > .text {
      margin-left: 0.256rem;
    }

    .image {
      margin-right: 0.256rem;
      display: block;
      width: 0.768rem;
      height: 0.768rem;
    }
  }

  .join-btn {
    margin-top: 0.853333rem;

    .btn {
      margin: auto;
      display: block;
      width: 3.413333rem;
      height: 1.109333rem;
      color: #ffffff;
      font-size: 0.512rem;
      line-height: 1.109333rem;
      text-align: center;
      border-radius: 0.938667rem;
      background: #0089ff;
    }
  }

  &.right {
    justify-content: flex-end;

    .info-wrap {
      border-radius: 0.597333rem 0 0.597333rem 0.597333rem;
    }
  }
}

.im-unknow {
  display: inline-block;
  vertical-align: top;
  padding: 0.512rem 0.597333rem;
  font-size: 0.64rem;
  line-height: 0.853333rem;
  font-weight: 400;
  white-space: pre-wrap;
  word-break: break-all;
  background: #d4ebff;
  box-shadow: 0rem 0.128rem 0.426667rem 0rem #ebeff9;
  border-radius: 0 0.597333rem 0.597333rem 0.597333rem;

  &.right {
    border-radius: 0.597333rem 0 0.597333rem 0.597333rem;
    .text-box {
      text-align: left;
    }
  }
}
</style>
